import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledGridItem = styled.div<{
  borderTopWidth: string;
  borderRightWidth: string;
  borderBottomWidth: string;
  borderLeftWidth: string;
}>`
  border-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  border-style: solid;
  border-top-width: ${({ borderTopWidth }) => borderTopWidth};
  border-right-width: ${({ borderRightWidth }) => borderRightWidth};
  border-bottom-width: ${({ borderBottomWidth }) => borderBottomWidth};
  border-left-width: ${({ borderLeftWidth }) => borderLeftWidth};
`;

export const StyledContainer = styled.div<StyledLabelProps>`
  width: ${({ theme }) => utils.rem(theme.Sizes.X8Large)};
  height: ${({ theme }) => utils.rem(theme.Sizes.X8Large)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};

  border: ${({ theme, selected }) =>
    selected
      ? `${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Brand.Primary}`
      : `${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border}`};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border: ${({ theme }) =>
      `${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Brand.Primary}`};
    color: ${({ theme }) => theme.Color.Brand.Primary};
  }
`;

export const StyledLabelContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface StyledLabelProps {
  selected?: boolean;
}

export const StyledLabel = styled.div<StyledLabelProps>`
  width: ${({ theme }) => utils.rem(theme.Spacing.Size.Large)};
  height: ${({ theme }) => utils.rem(theme.Spacing.Size.Large)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.XLarge)};
  background-color: ${({ theme }) => theme.Components.Panel.Background};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme, selected }) => (selected ? theme.Color.Brand.Primary : undefined)};

  &:hover {
    color: ${({ theme }) => theme.Color.Brand.Primary};
  }
`;

interface StyledInnerContainerProps {
  row: number;
  column: number;
}

const INNER_CONTAINER_WIDTH = 60;

export const StyledInnerContainer = styled.div<StyledInnerContainerProps>`
  width: ${utils.rem(INNER_CONTAINER_WIDTH)};
  height: ${utils.rem(INNER_CONTAINER_WIDTH)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium / 1.3)};
  background-color: ${({ theme }) => theme.Color.Neutrals.Border};
  display: grid;
  grid-template-columns: ${({ column }) => `repeat(${column}, 1fr)`};
  grid-template-rows: ${({ row }) => `repeat(${row}, 1fr)`};
`;
